import * as CONST from './const'

/**
 * Update city by id
 *
 * @param cityId
 */
export function getCityPickupTime(cityId) {
  return {
    type: CONST.GET_CITY_PICKUP_TIME,
    cityId,
  }
}

/**
 * Create city by id
 *
 * @param cityId
 * @param payload
 */
export function createCityPickupTime(cityId, payload) {
  return {
    type: CONST.CREATE_CITY_PICKUP_TIME,
    cityId,
    payload,
  }
}

/**
 * Get cities
 *
 * @param includesInactive
 * @returns {{type, includesInactive: boolean}}
 */
export function getCities(includesInactive = false) {
  return {
    type: CONST.CITY_GET_CITIES,
    includesInactive,
  }
}

/**
 * Set filter country
 *
 * @param {string} countryCode
 * @returns {{type, payload: {countryCode: string}}}
 */
export function setFilterCountry(countryCode) {
  return {
    type: CONST.CITY_SET_FILTER_COUNTRY,
    payload: {
      countryCode: countryCode,
    },
  }
}

/**
 * Set filter status
 *
 * @param {string} status
 * @returns {{type, payload: {status: string}}}
 */
export function setFilterStatus(status) {
  return {
    type: CONST.CITY_SET_FILTER_STATUS,
    payload: {
      status: status,
    },
  }
}

/**
 * Get city missions by cityId
 *
 * @param cityId
 * @returns {{type, cityId: *}}
 */
export function getCityMissions(cityId) {
  return {
    type: CONST.GET_CITY_MISSIONS,
    cityId,
  }
}

/**
 * Get city inventories by cityId
 *
 * @param cityId
 * @returns {{type, cityId: *}}
 */
export function getCityInventories(cityId) {
  return {
    type: CONST.GET_CITY_INVENTORIES,
    cityId,
  }
}

/**
 * Get city missions and inventories
 *
 * @param cityId
 * @returns {{type, cityId: *}}
 */
export function getCityMissionsAndInventories(cityId) {
  return {
    type: CONST.GET_CITY_MISSIONS_AND_INVENTORIES,
    cityId,
  }
}

export const updateCityByIdGraphQL = (cityId, payload) => ({
  type: CONST.UPDATE_CITY_BY_ID_GRAPH_QL,
  payload: { cityId, payload },
})



// WEBPACK FOOTER //
// ./src/Reducers/City/actions.js